import { render, staticRenderFns } from "./TheThirdModal.vue?vue&type=template&id=3269d63f&class=fill-height&"
import script from "./TheThirdModal.vue?vue&type=script&lang=ts&"
export * from "./TheThirdModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports